import { AxiosInstance } from 'axios';
import GroupEconomicService from './groupEconomicService';

export default function useGroupEconomic( axiosIns: AxiosInstance, groupEconomicOverrideConfig: Object ) {
  const groupEconomic = new GroupEconomicService( axiosIns, groupEconomicOverrideConfig )

  return {
    groupEconomic,
  }
}